import React from 'react';
import { Spin } from 'antd';

const CustomLoaderIcon = ({ size = 50 }) => (
  <div style={{
    width: size,
    height: size,
    border: '4px solid #1890ff',
    borderTop: '4px solid transparent',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  }} />
);

const Loader = ({ size = 50, height = '100vh', message = '' }) => {
  return (
    <div
      className='d-flex align-items-center justify-content-center w-100'
      style={{ height, background: '#fff' }}
    >
      <div className='d-flex flex-column align-items-center gap-2'>
        <Spin indicator={<CustomLoaderIcon size={size} />} />
        {message && (
          <span style={{ marginTop: '0', fontSize: '16px', color: '#555' }}>
            {message}
          </span>
        )}
      </div>
    </div>
  );
};

export default Loader;
